module.exports = __webpack_public_path__ + "static/6-2bd785d6458e158f21cca8f2ac849b66.png";